import { FC } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useSelector } from "react-redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { Check, PdAlert } from "src/components/Icons";

type tpPermanentRibbon = {
  onPress?: () => void;
};

const PermanentRibbon: FC<tpPermanentRibbon> = ({ onPress }: tpPermanentRibbon) => {
  const showPermanentRibbon = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.permanent);
  const message = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.permanentMessage);
  const status = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.permanentErrorType);
  const isSuccess = status === "SUCCESS";

  const handleOnPress = () => {
    onPress?.();
  };

  if (!showPermanentRibbon) {
    return null;
  }

  const IconComp = isSuccess ? Check : PdAlert;

  return (
    <TouchableOpacity style={styles.permanentRibbon} onPress={handleOnPress} disabled={!onPress} activeOpacity={0.95}>
      <View style={[styles.permanentRibbonWarning, isSuccess ? styles.bgGreen200 : styles.bgYellow200]} />
      <View style={[styles.flexRow, styles.alignCenter]}>
        <IconComp style={[styles.permanentRibbonIcon, styles.mr3]} color={kColors.brandDark} />
        <Text numberOfLines={1} style={styles.permanentRibbonLabel}>
          {message}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default PermanentRibbon;

const styles = StyleSheet.create({
  alignCenter: {
    alignItems: "center",
  },
  bgGreen200: {
    backgroundColor: kColors.green200,
  },
  bgYellow200: {
    backgroundColor: kColors.yellow200,
  },
  flexRow: {
    flexDirection: "row",
  },
  mr3: {
    marginRight: 3 * kStyleConst.kSpacing,
  },
  permanentRibbon: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderBottomWidth: 1,
    borderColor: kColors.brandDark,
    flexDirection: "row",
    height: kStyleConst.kErrorHeight,
    justifyContent: "flex-start",
    left: 0,
    paddingLeft: 6 * kStyleConst.kSpacing,
    position: "absolute",
    right: 0,
    top: kStyleConst.kHeaderHeight,
    zIndex: 99,
  },
  permanentRibbonIcon: {
    height: 15,
    width: 15,
  },
  permanentRibbonLabel: {
    ...kFonts.poppinsLight,
    color: kColors.brandDark,
    // marginLeft: 2 * kStyleConst.kSpacing,
  },
  permanentRibbonWarning: {
    height: "100%",
    left: 0,
    position: "absolute",
    width: 10,
  },
});
